export default __webpack_public_path__ + "static/MEDIA_SOBREBARRIGA-018209fe58d3b7cf5c3bb020e4243132.jpg";